import LogRocket from 'logrocket'

export default defineNuxtPlugin(() => {
  if (process.env.NODE_ENV === 'production') {
    LogRocket.init('7brb3d/hronboard')
    return { provide: { LogRocket } }
  }
})
